module.exports = __webpack_public_path__ + "b47d974247b4e587b9f2ec2551899900.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/candy.png
// module id = 2617
// module chunks = 0